import React from 'react';
import ChartistGraph from 'react-chartist';
import PropTypes from 'prop-types';

const LineAreaChart = ({ data }) => {
    const filteredData = data
        .filter(item => item.label)
        .sort((a, b) => a.label.localeCompare(b.label));

    const lineChartData = {
        labels: filteredData.map(item => item.label),
        series: [
            filteredData.map(item => item.sum)
        ]
    };

    const lineChartOptions = {
        low: 0,
        showArea: true,
    };

    return (
        <ChartistGraph 
            data={lineChartData} 
            style={{ height: "300px" }} 
            options={lineChartOptions} 
            type={'Line'} 
        />
    );
};

LineAreaChart.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            sum: PropTypes.number.isRequired
        })
    ).isRequired
};

LineAreaChart.defaultProps = {
    data: []
};

export default LineAreaChart;